import PropTypes from "prop-types";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FoundFoldersButtonIcon from "@mui/icons-material/FolderOpen";
import FilterButtonIcon from "@mui/icons-material/Tune";
import { Box, Button, Paper, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { useSearchModal } from "../../hooks";

import SimpleModalCompact from "../../components/common/ModalCompact/SimpleModalCompact";
import DetailedSearch from "../../components/DetailedSearch";
import FolderList from "../../components/DetailedSearch/FolderList";
import ProductList from "../../components/DetailedSearch/Products";

const useStyles = makeStyles(theme => ({
  buttonBar: {
    flex: "none",
    padding: 7,
    "& .MuiButton-root": {
      marginRight: 5,
      textTransform: "none",
    },
    "& .MuiButton-startIcon": {
      marginRight: 2,
    },
    "& .MuiButton-endIcon": {
      marginLeft: 2,
    },
  },
  modalBody: {
    backgroundColor: theme.palette.background.cream,
    padding: 8,
  },
}));

const ChevronButton = ({ icon, onClick, showChevron, text }) => (
  <Button
    endIcon={showChevron ? <ChevronLeftIcon /> : null}
    onClick={onClick}
    size="small"
    startIcon={icon}
    variant="outlined"
  >
    {text}
  </Button>
);

const Search = ({ onClose }) => {
  const classes = useStyles();

  const {
    filtersPanel,
    foldersPanel,
    toggleFiltersPanel,
    toggleFoldersPanel,
  } = useSearchModal();

  return (
    <SimpleModalCompact open fullScreen
      onClose={onClose}
      title={<FormattedMessage id="btn.search" />}
    >
      <Box className={classes.buttonBar}>
        <ChevronButton
          icon={<FilterButtonIcon />}
          onClick={toggleFiltersPanel}
          showChevron={filtersPanel}
          text={<FormattedMessage id="search.filter" />}
        />
        <ChevronButton
          icon={<FoundFoldersButtonIcon />}
          onClick={toggleFoldersPanel}
          showChevron={foldersPanel}
          text={<FormattedMessage id="search.foundFolders" />}
        />
      </Box>

      <Stack
        alignItems="stretch"
        justifyContent="space-between"
        spacing={1}
        sx={{ flexDirection: { md: "row", xs: "column" } }}
        useFlexGap
      >
        <Paper sx={{ display: filtersPanel ? "" : "none", minWidth: "30ch" }}>
          <DetailedSearch />
        </Paper>
        <Paper sx={{ display: foldersPanel ? "" : "none", minWidth: "20ch", padding: "10px" }}>
          <FolderList />
        </Paper>
        <Paper sx={{ flexGrow: 1 }}>
          <ProductList />
        </Paper>
      </Stack>
    </SimpleModalCompact>
  );
};

Search.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default Search;
